import {inject, Injectable} from '@angular/core';
import {timeout} from 'rxjs';
import {ConnectApiService} from './connect-api.service';

export interface RepositoryInstallation {
    id: string;
    repositoryUrl: string;
    repositoryId: number | null;
    status: 'queued' | 'checking' | 'building' | 'review_required' | 'installed' | 'failed';
    stage?: string;
    sourceCommit: string | null;
    installedCommit: string | null;
    installationId: string;
    version: string | null;
    autoUpdate: boolean;
    revision: number;
    errorCode: string | null;
    updatedAt: string;
}
export interface RepositoryInstallations {
    items: RepositoryInstallation[];
    capabilities: {configure: boolean};
    configured: boolean;
}

@Injectable({providedIn: 'root'})
export class ConnectRepositoriesService {
    private readonly api = inject(ConnectApiService);
    private readonly path = '/api/v1/integration-repositories';
    list() { return this.api.get<RepositoryInstallations>(this.path).pipe(timeout(15000)); }
    install(repositoryUrl: string, idempotencyKey: string, autoUpdate: boolean) {
        return this.api.post<RepositoryInstallation>(this.path, {repositoryUrl, idempotencyKey, autoUpdate}).pipe(timeout(15000));
    }
    updates(item: RepositoryInstallation, autoUpdate: boolean) {
        return this.api.put<RepositoryInstallation>(`${this.path}/${encodeURIComponent(item.id)}/updates`, {expectedRevision: item.revision, autoUpdate}).pipe(timeout(15000));
    }
    check(item: RepositoryInstallation, idempotencyKey: string) {
        return this.api.post<RepositoryInstallation>(`${this.path}/${encodeURIComponent(item.id)}/check`, {expectedRevision: item.revision, idempotencyKey}).pipe(timeout(15000));
    }
}
